import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { IReport } from '../../interface/IReport'
import { IOrdersRef } from '../../interface/IOrder'
import { useTranslation } from 'react-i18next'
import React from 'react'

const ReportPrintDetailsOrder = ({ type }: { type: string }) => {
    const report: IReport[] = useSelector((state: any) => state.report?.value)
    const orders: IOrdersRef[] = useSelector((state: any) => state.orders?.value)
    const { t } = useTranslation()
    let aggregatedData;
    let resultTable: any[] = [];

    if (type === 'ANÜ') {
        aggregatedData = report
            .flatMap((entry) => entry.calendarLines)
            .filter((line) => line.mserp_purchid && line.mserp_purchlinenumber)
            .reduce((acc, line) => {
                const key = `${line.mserp_purchid}-${line.mserp_purchlinenumber}`
                if (!acc[key]) {
                    acc[key] = { mserp_purchid: line.mserp_purchid, mserp_purchlinenumber: line.mserp_purchlinenumber, mserp_calculatedtimeseconds: 0 }
                }
                acc[key].mserp_calculatedtimeseconds += line.mserp_calculatedtimeseconds / 60.0 / 60.0 || 0
                return acc
            }, {})

        resultTable = Object.values(aggregatedData).map((entry: any) => ({
            Bestellung: entry.mserp_purchid,
            Positionsnr: entry.mserp_purchlinenumber,
            Menge: entry.mserp_calculatedtimeseconds,
        }))
    }else if(type === 'FAK'){
        aggregatedData = orders
            .filter((line) => line.mserp_purchid && line.mserp_linenumber)
            .reduce((acc: { [key: string]: { mserp_purchid: string | undefined, mserp_linenumber: number | undefined, mserp_hours: number | undefined } }, line) => {
                const key = `${line.mserp_purchid}-${line.mserp_linenumber}`
                if (!acc[key]) {
                    const amount = report.flatMap((entry) => entry.calendarLines)
                        .filter((reportLine) => line.mserp_purchlinerecid === reportLine.mserp_mbpurchlinerefrecid)
                        .reduce((sum, curr) => sum + (curr.mserp_hours || 0), 0)
                    acc[key] = { mserp_purchid: line.mserp_purchid, mserp_linenumber: line.mserp_linenumber, mserp_hours: amount }
                }
                return acc
            }, {})

        resultTable = Object.values(aggregatedData).map((entry: any) => ({
            Bestellung: entry.mserp_purchid,
            Positionsnr: entry.mserp_linenumber,
            Menge: entry.mserp_hours,
        }))
    }

    return (
        <Box className="printContents" mb={2} mt={4}>
            <Typography variant="h5">{t('report.orders')}</Typography>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('report.order')}</TableCell>
                            <TableCell align="right">{t('report.orderlineno')}</TableCell>
                            <TableCell align="right">{t('report.amount')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {resultTable.map((aggregatedItem) => (
                            <TableRow key={resultTable.indexOf(aggregatedItem)}>
                                <TableCell>{aggregatedItem.Bestellung}</TableCell>
                                <TableCell align="right">{aggregatedItem.Positionsnr}</TableCell>
                                <TableCell align="right">{aggregatedItem.Menge.toFixed(2)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default ReportPrintDetailsOrder
